<template>
	<GlassCard class="p-2 macro">
		<h2 class="p-3">Today's Nutrition Ratio</h2>
		<canvas ref="canvas" v-show="!isEmpty"></canvas>
		<div v-show="isEmpty">No data right now.</div>
	</GlassCard>
</template>

<script setup>
	import { ref, watch, onMounted, computed, onBeforeMount, onBeforeUnmount } from "vue"
	import GlassCard from "./GlassCard.vue"
	import Chart from "chart.js/auto"
	import { useTokenStore } from "@/stores/token"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"

	const selectedMonth = ref(new Date().toISOString().substring(0, 7))
	const nutritionData = ref([])
	const canvas = ref(null)

	const tokenStore = useTokenStore()

	let myChart = null

	const isEmpty = computed(() => {
		return (
			nutritionData.value.totalProtein === 0 &&
			nutritionData.value.totalCarbs === 0 &&
			nutritionData.value.totalFats === 0 &&
			nutritionData.value.totalCholesterol === 0
		)
	})

	onMounted(() => {
		// console.log(canvas.value)
		fetchNutritionData(selectedMonth.value)
	})

	async function fetchNutritionData(month) {
		if (typeof month === "string") {
			// console.log(month)
			// const [year, monthPart] = month.split("-")
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth(`/api/report/macronutrition`, {
				method: "GET",
				headers: {
					"User-Timezone": tz,
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			nutritionData.value = await response.json()

			if (myChart) {
				myChart.destroy()
			}

			myChart = new Chart(canvas.value, {
				type: "doughnut",
				data: {
					labels: ["Calories", "Protein", "Carbs", "Fats", "Cholesterol"],
					datasets: [
						{
							label: "Macronutrient Ratios",
							data: [
								// 10, 40, 20,
								// 112, 1, 1,
								nutritionData.value.totalCalories,
								nutritionData.value.totalProtein,
								nutritionData.value.totalCarbs,
								nutritionData.value.totalFats,
								nutritionData.value.totalCholesterol,
							],
							backgroundColor: [
								"#4e79a7",
								"#f28e2b",
								"#e15759",
								"#76b7b2",
								"#59a14f",
							],
							hoverOffset: 4,
						},
					],
				},
				options: {
					// aspectRatio: 1,
					// responsive: true,
					// maintainAspectRatio: false,
					plugins: {
						legend: {
							labels: {
								color: "white",
							},
						},
					},
				},
			})
			// }
		}
	}

	watch(
		selectedMonth,
		(newMonth) => {
			fetchNutritionData(newMonth)
		}
		// { immediate: true }
	)

	// watch(lastMealUpdated, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	// watch(lastMealDeleted, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", (updatedMeal) => {
			if (!updatedMeal) return
			fetchNutritionData(selectedMonth.value)
		})

		offMealDeleted = EventBus.on("meal-deleted", (deletedMealId) => {
			if (!deletedMealId) return
			fetchNutritionData(selectedMonth.value)
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})
</script>

<style lang="less" scoped>
	.macro {
		min-height: 400px;
		height: 100%;
	}

	canvas {
		max-height: 400px;
	}
</style>
